//TODO Floating JS
let floatinput = () => {
    const floatinputboxes = document.querySelectorAll('.input-box-dekaz')
    if (floatinputboxes) {
        floatinputboxes.forEach(floatinputbox => {
            const floatinput = floatinputbox.querySelector('.input-text-dekaz')
            let label = document.createElement('label');
            label.innerHTML = floatinput.getAttribute('placeholder');
            label.className = 'label-text-dekaz';

            floatinput.parentNode.insertBefore(label, floatinput);
            floatinput.setAttribute('placeholder', '')

            floatinput.addEventListener('focus', () => {
                label.classList.add('active')
            })
            floatinput.addEventListener('blur', () => {
                if (floatinput.value === '') {
                    label.classList.remove('active')
                }
            })
            floatinput.addEventListener('change', () => {
                if (floatinput.value != '') {
                    floatinputbox.classList.remove('invalid')
                }
            })
        })
    }
}

floatinput()
